import { safeParse, safeParseNullDefault } from 'shouldve-been-js';

class InspectingCompany {

    private _companyId: string;
    private _name: string;
    private _status: string;

    public constructor(companyId: string, name: string, status: string) {

        this._companyId = companyId;
        this._name = name;
        this._status = status;
    }

    public get companyId(): string {
        return this._companyId;
    }

    public set companyId(value: string) {
        this._companyId = value;
    }

    public get name(): string {
        return this._name;
    }

    public set name(value: string) {
        this._name = value;
    }

    public get status(): string {
        return this._status;
    }

    public set status(value: string) {
        this._status = value;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    public static fromJson(json: any): InspectingCompany | null {

        const companyId: string | null = safeParseNullDefault<string>(json?.companyId, '');
        const name: string = safeParse<string>(json?.name, '');
        const status: string = safeParse<string>(json?.status, '');
        
        if (companyId === null || companyId === '') {
            return null;
        }

        return new InspectingCompany(companyId, name, status);
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    public static fromIndexedDB(object: any): InspectingCompany | null {

        const companyId: string | null = safeParseNullDefault<string>(object?._companyId, '');
        const name: string = safeParse<string>(object?._name, '');
        const status: string = safeParse<string>(object?._status, '');
        
        if (companyId === null || companyId === '') {
            return null;
        }

        return new InspectingCompany(companyId, name, status);
    }
}

export default InspectingCompany;